import { BookOpen, Mail, Github, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t bg-card mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <BookOpen className="h-6 w-6 text-primary" />
              <span className="text-lg font-bold">FaydaLibrary</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Your gateway to thousands of eBooks. Read, learn, and grow with our digital library.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-muted-foreground hover:text-primary">Home</Link></li>
              <li><Link to="/library" className="text-muted-foreground hover:text-primary">Browse Library</Link></li>
              <li><Link to="/about" className="text-muted-foreground hover:text-primary">About Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3">Categories</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/library?category=fiction" className="text-muted-foreground hover:text-primary">Fiction</Link></li>
              <li><Link to="/library?category=non-fiction" className="text-muted-foreground hover:text-primary">Non-Fiction</Link></li>
              <li><Link to="/library?category=technology" className="text-muted-foreground hover:text-primary">Technology</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3">Connect</h3>
            <div className="flex gap-3">
              <a href="#" className="text-muted-foreground hover:text-primary">
                <Mail className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary">
                <Github className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>© 2025 FaydaLibrary. Built with WordPress headless architecture.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
